var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "currency-input" },
    [
      _c(
        "b-col",
        { staticClass: "input-group bill-field", attrs: { sm: _vm.size } },
        [
          _c("div", { staticClass: "input-group-prepend" }, [
            _c("span", { staticClass: "input-group-text" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.currencySymbol
                      ? _vm.currencySymbol
                      : _vm.getVendor.local_currency
                  ) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "form-control currency",
            attrs: {
              type: "text",
              min: "0",
              placeholder: "0",
              required: "",
              value: _vm.amountDisplay,
              title: _vm.name,
              disabled: _vm.disabled,
              state: _vm.fieldState,
            },
            on: { change: _vm.updateAmount },
            nativeOn: {
              keydown: function ($event) {
                return _vm.keymonitor.apply(null, arguments)
              },
            },
            model: {
              value: _vm.value,
              callback: function ($$v) {
                _vm.value = $$v
              },
              expression: "value",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }